import React from "react";
import { CardMedia } from "@mui/material";

const upgradeToHttps = (url) => {
  if (url && url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  return url;
};

const PostMediaCard = ({ imageUrl }) => {
  const defaultImage = 'https://mrapi.mruns.com/wp-content/uploads/2020/01/83798790_2842918695768253_5984271632523329536_o-480x162.jpg';
  
  const displayImage = upgradeToHttps(imageUrl) || defaultImage;

  return (
    <CardMedia
      component="img"
      sx={{
        height: 200, 
        backgroundColor: '#eee'
      }}
      image={displayImage}
      alt="Blog post image"
    />
  );
};

export default PostMediaCard;
